import { Component } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

@Component({
  selector: 'app-relatorio-mercadorias-vendidas',
  templateUrl: './relatorio-mercadorias-vendidas.component.html',
  styleUrls: ['./relatorio-mercadorias-vendidas.component.scss']
})
export class RelatorioMercadoriasVendidasComponent {
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  numerosCtrl = new FormControl();
  numerosPedidos: string[] = [];
  numeroMaximoContPedidos: Number;
  bConsulta: boolean = false;
  totalIndividualProdutosComprados = [];
  contTotalProdutosGeral: number = 0;
  uid;

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private router: Router,
  ) {
    this.uid = localStorage.getItem('uid');

    this.usuarioService.getContIdPedidos().subscribe(snap => {
      const cont: any = snap;
      this.numeroMaximoContPedidos = cont;
    });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (!this.numerosPedidos.includes(value)) {
      if (Number(value) <= this.numeroMaximoContPedidos && Number(value) >= 1) {
        this.numerosPedidos.push(value);
      } else
        this.toastr.warning('Este pedido não existe', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    } else
      this.toastr.warning('Você já adicionou este pedido à lista', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

    // Clear the input value
    event.value = '';

    this.numerosCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.numerosPedidos.indexOf(fruit);

    if (index >= 0) {
      this.numerosPedidos.splice(index, 1);
    }
  }

  async gerarRelatorio() {
    this.spinner.show('relatorio-mercadorias-vendidas');
    if (this.numerosPedidos.length > 0) {
      let cont = 0;
      this.totalIndividualProdutosComprados = [];
      this.contTotalProdutosGeral = 0;

      Promise.all(this.numerosPedidos.map((idPedido) => {
        return this.usuarioService.getProdutosPedido(Number(idPedido)).pipe(take(1)).subscribe(snap => {
          if (snap) {
            const dados: any = snap.payload.val();

            if (dados && dados.Status !== 'Cancelado') {
              dados.Produtos ? dados.Produtos.forEach((item) => {
                const aux: any = item;

                const index = this.totalIndividualProdutosComprados.findIndex(x => x.Key === aux.Key);
                index !== -1 ? this.totalIndividualProdutosComprados[index].QuantidadeComprada = (this.totalIndividualProdutosComprados[index].QuantidadeComprada + aux.QuantidadeComprada) : this.totalIndividualProdutosComprados.push({ Key: aux.Key, QuantidadeComprada: aux.QuantidadeComprada, Grupo: aux.Grupo, Nome: aux.Nome });
                this.contTotalProdutosGeral += aux.QuantidadeComprada;
              }) : null;
            }
          }
          cont++;
          cont === this.numerosPedidos.length ? this.finalizarRelatorio() : null;
          return;
        });

        // console.log(resp)
      })).catch(err => {
        this.toastr.error('Houve um erro ao gerar o relatório', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        setTimeout(() => this.spinner.hide('relatorio-mercadorias-vendidas'), 300);
      });
    } else
      this.toastr.warning('Informe ao menos 1 pedido', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
  }

  finalizarRelatorio() {

    this.totalIndividualProdutosComprados.sort((a, b) => a.Nome.localeCompare(b.Nome));

    this.bConsulta = true;
    setTimeout(() => this.spinner.hide('relatorio-mercadorias-vendidas'), 300);
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: false, bCSV: false },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo)
      }
    });
  }

  imprimir(tipo) {
    let date: Date = new Date();

    const map = {
      ImpressaoProdutosPedidos: JSON.stringify(this.totalIndividualProdutosComprados),
      DataImpressao: this.usuarioService.tratarData(date.getTime())
    }

    switch (tipo) {
      //PDF
      case 0:
        let doc: any = new jsPDF('p', 'mm', [297, 210]);
        let corpo: any = [];
        this.totalIndividualProdutosComprados.forEach(dado => {
          var aux = [dado.Nome, dado.Grupo, dado.QuantidadeComprada];
          corpo.push(aux);
        });

        autoTable(doc, {
          head: [["Produto", "Grupo", "Total"]],
          theme: 'grid',
          body: corpo,
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          showHead: 'firstPage',
          showFoot: 'lastPage',
          foot: [["", "", "Total: " + this.contTotalProdutosGeral]]
        });

        let auxNumPedidos = 'Pedidos: ';
        for (let i = 0; i < this.numerosPedidos.length; i++) {
          auxNumPedidos = auxNumPedidos + this.numerosPedidos[i] + '; ';
        }

        doc.autoTable({
          theme: 'striped',
          columnStyles: { 0: { halign: 'left' }, },
          body: [[auxNumPedidos]],
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          startY: doc.previousAutoTable.finalY + 50,
          showHead: 'firstPage',
          showFoot: 'lastPage',
        });


        doc.save('Relatório_Produtos_Pedidos_' + this.usuarioService.tratarData(date.getTime()) + '.pdf');

        this.usuarioService.setLog("Exportou relatório de produtos em PDF. Período: " + this.usuarioService.tratarData(date.getTime()), map, this.uid);
        break;
    }
  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/relatorio-mercadorias-vendidas"]));
  }

}
